import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import 'whatwg-fetch';
import data_wall_event from '../../../data/wall-event';

const linkToUser = '/dashboard/user/';
const linkToPost = '/dashboard/post/';

export default class WallCard extends React.Component {
  constructor(props) {
    super(props);

    this.paragraph = null;

    this.setParagraphRef = (element) => {
      this.paragraph = element;
    };

    this.state = {
      extended: false, // See More/Less
      paragraphMinified: false,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.toggleExtended = this.toggleExtended.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  componentDidMount() {
    this.isParagraphMinified();
  }

  isParagraphMinified() {
    this.setState({
      paragraphMinified: this.paragraph && this.paragraph.scrollHeight > this.paragraph.clientHeight,
    });
  }

  toggleExtended() {
    this.setState({
      extended: !this.state.extended,
    });
  }

  htmlLineBreak(text) {
    let res = text.replace(/\r\n/g, '<br/>');
    res = res.replace(/\n/g, '<br/>');
    res = res.replace(/\r/g, '<br/>');
    return res;
  }

  printPin(title) {
    let res = this.isPinned(title) ? title.slice(10) : title;
    return res;
  }

  isPinned(title) {
    return title && title.startsWith('/*PINNED*/');
  }

  render() {
    if (!this.props.data) return null;

    const { data } = this.props;

    return (
      <li>
        <div className='timelineV-badge success'>
          <span
            className={
              'icon icon-' +
              (!('linkType' in data)
                ? data_wall_event['POST'].icon
                : data_wall_event[data.type]
                ? data_wall_event[data.type].icon
                : '')
            }
          />
        </div>
        <div className='timelineV-panel'>
          <div className='timelineV-heading'>
            {!('linkType' in data) ? (
              <div className='timelineV-title-command'>
                <Link to={linkToPost + data.id}>
                  <h4 className='timelineV-title'>
                    {data.title && data.title.trim() !== '' ? this.printPin(data.title) : 'Commentaire'}
                  </h4>
                </Link>
                <div>
                  {this.isPinned(data.title) ? (
                    <span onClick={() => this.props.pinPost(data)} className='icon icon-pin cursor'></span>
                  ) : (
                    <button
                      onClick={() => this.props.pinPost(data)}
                      type='button'
                      className='btn btn-sm btn-outline-success'
                    >
                      <span className='icon icon-pin'></span>
                    </button>
                  )}
                  <Link to={linkToPost + data.id}>
                    <button type='button' className='btn btn-sm btn-outline-success'>
                      <span className='icon icon-pencil'></span>
                    </button>
                  </Link>
                  <button
                    onClick={() => this.props.deletePost(data.id)}
                    type='button'
                    className='btn btn-sm btn-outline-success'
                  >
                    <span className='icon icon-cross'></span>
                  </button>
                </div>
              </div>
            ) : (
              <h4 className='timelineV-title'>{data.title}</h4>
            )}

            {(data.dateCreate || data.creator) && (
              <p>
                <small className='text-muted'>
                  <span className={'icon icon-stopwatch'} />
                  {data.dateCreate ? 'le ' + moment(data.dateCreate).format('DD-MM-YY à HH:mm ') : ''}
                  {data.creator && (
                    <Link to={linkToUser + data.creator.user.id}>
                      {data.creator ? 'par ' + data.creator.user.username : ''}
                    </Link>
                  )}
                </small>
              </p>
            )}
          </div>
          <div className={'timelineV-body ' + (this.state.extended ? 'extended' : '')}>
            {data.text && (
              <p
                ref={this.setParagraphRef}
                dangerouslySetInnerHTML={{
                  __html: this.htmlLineBreak(data.text),
                }}
              ></p>
            )}
            {data.text && this.state.paragraphMinified && (
              <span className='text-clickable' onClick={this.toggleExtended}>
                {!this.state.extended ? 'Voir plus' : 'Voir moins'}
              </span>
            )}
          </div>
          {data.id && data.attachments && (
            <div className='attachment-list-horizontal'>
              {data.attachments.slice(0, 3).map((file, id) => (
                <a target='_blank' href={'/' + file.name} key={id}>
                  <div className='attachment-card' title={file.name.split('/')[file.name.split('/').length - 1]}>
                    <span className='icon icon-attachment'>
                      {file.name.split('/')[file.name.split('/').length - 1]}
                    </span>
                  </div>
                </a>
              ))}
              {data.attachments.length > 3 && (
                <Link to={linkToPost + data.id}>
                  <div className='attachment-card'>
                    <span className='icon icon-attachment'>{'+' + (data.attachments.length - 3)}</span>
                  </div>
                </Link>
              )}
            </div>
          )}
        </div>
      </li>
    );
  }
}
